export default __webpack_public_path__ + "static/media/oval_solid.0ca136e9.png";